export const INSTRUCTIONAL_MATERIALS_TYPE = 'instructional_materials';
export const EDUCATION_TYPE = 'education';
